var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionEditBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9853 3.60534L12.3973 5.01667M11.8933 2.36201L8.07527 6.18001C7.878 6.37701 7.74345 6.628 7.6886 6.90134L7.33594 8.66667L9.10127 8.31334C9.3746 8.25867 9.62527 8.12467 9.8226 7.92734L13.6406 4.10934C13.7553 3.99461 13.8463 3.8584 13.9084 3.7085C13.9705 3.55859 14.0025 3.39793 14.0025 3.23567C14.0025 3.07342 13.9705 2.91275 13.9084 2.76285C13.8463 2.61294 13.7553 2.47674 13.6406 2.36201C13.5259 2.24728 13.3897 2.15627 13.2398 2.09417C13.0899 2.03208 12.9292 2.00012 12.7669 2.00012C12.6047 2.00012 12.444 2.03208 12.2941 2.09417C12.1442 2.15627 12.008 2.24728 11.8933 2.36201Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 10V12C12.668 12.3536 12.5275 12.6928 12.2774 12.9428C12.0274 13.1929 11.6883 13.3333 11.3346 13.3333H4.0013C3.64768 13.3333 3.30854 13.1929 3.05849 12.9428C2.80844 12.6928 2.66797 12.3536 2.66797 12V4.66668C2.66797 4.31305 2.80844 3.97392 3.05849 3.72387C3.30854 3.47382 3.64768 3.33334 4.0013 3.33334H6.0013",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionEditBtn);
export default __webpack_public_path__ + "static/media/action-edit-btn.3f9720cae9882f28cf00d7baca652b81.svg";
export { ForwardRef as ReactComponent };